
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vip/info",
      function () {
        return require("private-next-pages/vip/info/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vip/info"])
      });
    }
  